import { render } from "./403.vue?vue&type=template&id=81ce09fc&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"

import "./403.vue?vue&type=style&index=0&id=81ce09fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-81ce09fc"

export default script